import {ILogDto, Log} from "@/modules/Segmentation/models/Log";
import {ILogService, LogSearchFilterEnum} from "@/modules/Segmentation/services/ILoggerService";
import {IHttpService} from "frontend-core";
import {inject, injectable} from "tsyringe";
import {IPaginationDto, IPaginationModel, SortType} from "@/models/Pagination";

@injectable()
export class LogService implements ILogService {
    constructor(
        @inject("IHttpService")
        private readonly httpService: IHttpService,
    ) {
    }

    get(id: string): Promise<Log | null>;
    get(
        filter?: LogSearchFilterEnum,
        search?: string | string[],
        page?: number,
        countPerPage?: number,
        createdAtSort?: SortType,
    ): Promise<IPaginationModel<Log>>;
    async get(
        filterOrId?: LogSearchFilterEnum | string,
        search?: string,
        page?: number,
        countPerPage: number = 20,
        createdAtSort: SortType = SortType.desc,
    ): Promise<IPaginationModel<Log> | Log | null> {
        if (filterOrId && !search) {
            let log: Log | null = null;

            await this.httpService.api.get<ILogDto>(`/logs/${filterOrId}`)
                .then((data) => {
                    log = new Log(data.data);
                })
                .catch(() => {
                    log = null;
                });

            return log;
        } else {
            let array: Log[] = [];
            let count: number = 0;

            const url: string = !!filterOrId && !!search
                ? `/logs?${filterOrId}=${encodeURIComponent(search)}&topic[]=check_target&topic[]=auto_segment&page=${page}&pagination=true&order[createdAt]=${createdAtSort}`
                : `/logs?topic[]=check_target&topic[]=auto_segment&order[createdAt]=${createdAtSort}`;

            await this.httpService.api.get<ILogsHydra>(url, {
                headers: {
                    "Accept": "application/ld+json"
                }
            })
                .then((data) => {
                    array = data.data["hydra:member"].map(i => new Log(i));
                    count = Math.ceil(data.data["hydra:totalItems"] / countPerPage);
                })
                .catch(() => {
                    array = [];
                });

            return {
                items: array,
                pagesCount: count,
            };
        }
    }
}

export type ILogsHydra = IPaginationDto<ILogDto>
